import React, { useEffect, useState } from 'react';
import './RadioButtonFieldComponent.scss';
import { useUploadPicture } from '@/features/location/api/locationRequests';
import { FormField } from '../types';
type RadioButtonFieldComponentProps = {
  data?: FormField;
  onChange?: (data: string) => void;
  disabled?: boolean;
};
export const RadioButtonFieldComponent = ({
  data,
  disabled,
  onChange,
}: RadioButtonFieldComponentProps) => {
  const uploadPicture = useUploadPicture();
  const [radioFieldData, setRadioFieldData] = useState<string>('');
  useEffect(() => {
    if (data) {
      setRadioFieldData(data.fieldValue);
    }
  }, [data]);
  const onRadioChange = (value: string) => {
    setRadioFieldData(value);
    onChange && onChange(value);
  };
  return (
    <div className={`radio-field ${data?.options && data?.options.length > 3 ? 'wrap' : ''}`}>
      <div className="pet-row pl-2">
        <div className="p-radio-group p-pl-30">
          {data?.options &&
            data?.options.map((fo, index) => (
              <>
                <label className="container-1">
                  <span>{fo.label}</span>
                  <input
                    key={`radio-${data.fieldName.trim().toLowerCase() + index}`}
                    type="radio"
                    name={`radio-${data.fieldName.trim().toLowerCase()}`}
                    disabled={disabled}
                    onChange={() => onRadioChange(fo.value)}
                    checked={radioFieldData === fo.value}
                  />
                  <span className={`checkmark ${radioFieldData ? '' : 'empty'}`}></span>
                </label>
                {data.options && data.options?.length - 1 !== index && (
                  <div className="pet-details-divider"></div>
                )}
              </>
            ))}
        </div>
      </div>
    </div>
  );
};
